module.exports = __webpack_public_path__ + "media/svg/icon_fit_purple-f01c59f2.svg";